// [生成时间:2026-06-23], [生成当前代码的ai模型名称:]

import { request, _getCookie, arenaBaseURL } from './http'
import Vue from 'vue'
import store from '../store'
import axios from 'axios'
import router from '../router'
import betterwe from '@/common/app-common.js'
import dataObj from '@/common/date.js'
import { Toast } from 'vant'
import BaseData from './base.js'
import VConsole from 'vconsole'

/**
 * 环境配置
 * 支持环境: dev(开发), test(测试), pre(预发布), pro(正式)
 */
const ENV_CONFIG = {
  // 李静减脂营 API 配置
  ljApi: {
    dev: 'https://tfat-loss-camp.gymcity.com.cn/',
    test: 'https://tfat-loss-camp.gymcity.com.cn/',
    pre: 'https://tfat-loss-camp.gymcity.com.cn/',
    pro: 'https://fat-loss-camp.gymcity.com.cn/'
  },
  // 健萌 2.0 API 配置
  gym2Api: {
    dev: 'https://t.gymcity.com.cn/',
    test: 'https://t.gymcity.com.cn/',
    pre: 'https://t.gymcity.com.cn/',
    pro: 'https://api.gymcity.com.cn/'
  },
  // 公众号 H5 项目配置
  vueH5: {
    dev: 'http://vue.gym2.com/#/',
    test: 'https://test.gymcity.com.cn/#/',
    pre: 'https://test.gymcity.com.cn/#/',
    pro: 'https://vue.gymcity.com.cn/#/'
  },
  // 公众号 H5 项目配置（?path= 跳转方式）
  vueH5Path: {
    dev: 'http://vue.gym2.com/?path=',
    test: 'https://test.gymcity.com.cn/?path=',
    pre: 'https://test.gymcity.com.cn/?path=',
    pro: 'https://vue.gymcity.com.cn/?path='
  },
  // 小程序 API 配置
  appApi: {
    dev: 'https://tbtwx.gymcity.com.cn/',
    test: 'https://tbtwx.gymcity.com.cn/',
    pre: 'https://betabtwx.gymcity.com.cn/',
    pro: 'https://btwx.gymcity.com.cn/'
  },
  // APP 端接口配置
  baseApp: {
    dev: 'https://tbtapp.gymcity.com.cn/',
    test: 'https://tbtapp.gymcity.com.cn/',
    pre: 'https://betabtapp.gymcity.com.cn/',
    pro: 'https://btapp.gymcity.com.cn/'
  },
  // We API 配置
  weApi: {
    dev: 'https://twe.betterwestar.com/',
    test: 'https://twe.betterwestar.com/',
    pre: 'https://we.betterwestar.com/',
    pro: 'https://we.betterwestar.com/'
  },
  // 图片上传配置
  imageUpload: {
    dev: 'https://api3t.gymcity.com.cn/member/active',
    test: 'https://api3t.gymcity.com.cn/member/active',
    pre: 'https://api3t.gymcity.com.cn/member/active',
    pro: 'https://api3.gymcity.com.cn/member/active'
  },
  // 数据统计配置
  dataLog: {
    dev: 'https://twe.betterwestar.com/api/lowCodeLogPush',
    test: 'https://twe.betterwestar.com/api/lowCodeLogPush',
    pre: 'https://we.betterwestar.com/api/lowCodeLogPush',
    pro: 'https://we.betterwestar.com/api/lowCodeLogPush'
  }
}

/**
 * 根据域名判断当前环境
 * @returns {string} 环境类型: dev|test|pre|pro
 */
function getCurrentEnv() {
  const href = location.href

  // 正式环境
  if (
    href.indexOf('btvue.gymcity.com.cn') !== -1 &&
    href.indexOf('tbtvue.gymcity.com.cn') === -1 &&
    href.indexOf('betabtvue.gymcity.com.cn') === -1
  ) {
    return 'pro'
  }

  // 预发布环境
  if (href.indexOf('betabtvue.gymcity.com.cn') !== -1) {
    return 'pre'
  }

  // 测试环境
  if (href.indexOf('tbtvue.gymcity.com.cn') !== -1) {
    return 'test'
  }

  // 开发环境
  return 'dev'
}

/**
 * 根据环境获取对应的 URL
 * @param {string} configKey 配置键名，如 'gym2Api', 'vueH5' 等
 * @param {string} path URL 路径
 * @returns {string} 完整的 URL
 */
function getEnvUrl(configKey, path = '') {
  const env = getCurrentEnv()
  const baseUrl = ENV_CONFIG[configKey] && ENV_CONFIG[configKey][env]
  return baseUrl ? baseUrl + path : path
}

/**
 * 获取旧版本环境标识 (用于兼容旧代码)
 * @returns {string} 环境类型: Dev|Test|Pro
 */
function getLegacyEnv() {
  const env = getCurrentEnv()
  const envMap = {
    dev: 'Dev',
    test: 'Test',
    pre: 'Test',
    pro: 'Pro'
  }
  return envMap[env] || 'Dev'
}

const clientplatformData = [
  {
    id: 1,
    name: 'Android'
  },
  {
    id: 2,
    name: 'IOS'
  }
]
function getClientplatform(id) {
  let res = clientplatformData.find((item) => {
    return item.id == id
  })
  return (res && res.name) || ''
}
let _UserInfo = null //用户信息
let userInfoApiList = [] //用户信息promise列表
let appDeviceInfo = null
//app版本信息
let headerParams = {
  env: '',
  deviceversion: '',
  clientplatform: 1,
  clientversion: '88',
  clientname: '',
  deviceid: '',
  manufacturer: '',
  brand: '',
  lat: '',
  lon: '',
  appchannel: '',
  useragent: '',
  idfa: '',
  isexamined: ''
}
let vConsole = null

/**
 * 初始化 VConsole 调试工具
 * 在非正式环境下自动加载 VConsole
 * 正式环境下，若 URL 上携带 vconsole=1 参数也强制开启，便于线上排查
 */
function initVConsole() {
  if (vConsole) {
    return
  }

  const env = getCurrentEnv()
  // 正式环境下，仅当 URL 参数 vconsole=1 时才显示
  const isForceVConsole =
    env === 'pro' && /(?:^|[?&])vconsole=1(?:&|$)/.test(location.search)

  if (env !== 'pro' || isForceVConsole) {
    vConsole = new VConsole()
    console.log(
      `[VConsole] 当前环境: ${env}${isForceVConsole ? ' (URL 强制开启)' : ''}`
    )
  }
}

betterwe.getAppDevicesInfo().then((res) => {
  appDeviceInfo = res
  for (let key in headerParams) {
    if (res[key]) {
      headerParams[key] = res[key]
    }
  }

  // APP 环境下初始化 VConsole
  initVConsole()
  console.log('app版本信息', res)
})
class HTTP {
  // 添加静态属性存储 token promise
  static tokenPromise = null
  // 构造函数
  constructor() {
    // H5 环境下初始化 VConsole
    if (!this._isApp()) {
      initVConsole()
    }
  }
  // 获取当前环境是正式，测试 (兼容旧版本逻辑)
  getEnv() {
    return getLegacyEnv()
  }
  // 跳转 公众号H5项目
  _toVueH5Url(url, type = 'push', title) {
    // 添加经纬度参数
    if (!url.includes('lat=') && !url.includes('lng=')) {
      const lat = (store.state.location && store.state.location.lat) || ''
      const lng = (store.state.location && store.state.location.lng) || ''
      url = url + `${url.includes('?') ? '&' : '?'}lat=${lat}&lng=${lng}`
    }
    url = getEnvUrl('vueH5', url)
    if (this._isApp()) {
      betterwe.jumpRoute(
        `/web?isJM=1&isAddToken=false&isShowTitle=true&title=${encodeURIComponent(
          title || document.title
        )}&url=${encodeURIComponent(url)}`
      )
    } else {
      if (url.indexOf('token=') == -1) {
        this._setCookie('token', this._getCookie('jmToken'))
      }
      if (type == 'push') {
        location.href = url
      } else {
        location.replace(url)
      }
    }
  }
  // 跳转 公众号H5项目（?path=方式） 支持携带参数
  // _newToVueH5Url('activity-mt-live', { id: 1, name: '张三' })
  // → https://vue.gymcity.com.cn/?path=activity-mt-live&id=1&name=%E5%BC%A0%E4%B8%89
  _newToVueH5Url(path, params = {}, type = 'push') {
    const query = Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== null)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&')
    // vueH5Path 形如 'http://vue.gym2.com/?path='，path 直接拼接
    let url = getEnvUrl('vueH5Path', path)
    if (query) {
      url = url + '&' + query
    }
    console.log('[VConsole] _newToVueH5Url:', url)
    if (type == 'push') {
      location.href = url
    } else {
      location.replace(url)
    }
  }
  // 获取 公众号H5项目链接
  _getVueH5Url(url = '') {
    return getEnvUrl('vueH5', url)
  }
  // 判断当前环境可 是否是小程序
  _isMini() {
    return new Promise((resolve, reject) => {
      if (window['wx'].miniProgram) {
        window['wx'].miniProgram.getEnv((res) => {
          resolve(res.miniprogram)
        })
      } else {
        resolve(false)
      }
    })
  }
  // 配置小程序环境时的分享
  _shareMini(data) {
    // 小程序分享配置
    // const miniObj = {
    //   title: obj.miniTitle || window["shareData"].title,
    //   imageUrl: obj.miniImgUrl || window["shareData"].imgUrl,
    //   path:
    //     "/pages/webview/webview?url=" +
    //     encodeURIComponent(
    //       window["shareData"].link.split("path=")[1].replace("&", "?")
    //     )
    // };
    // 判断是小程序环境后发送
    this._isMini().then((res) => {
      if (res) {
        window['wx'].miniProgram.postMessage({
          data
        })
      }
    })
  }
  // flag = 0
  // 判断当前环境 是否是app
  _isApp() {
    return betterwe.isApp()
  }
  // 获取hash链接中的参数
  _getQuery(val) {
    const w = location.search.indexOf('?')
    const query = location.search.substring(w + 1)
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      if (pair[0] == val) {
        return pair[1]
      }
    }
    return false
  }
  // 获取cookie的token 只获取cookie中的   http.js中的_getCookie 还判断获取了Storage中的
  _getCookie(name) {
    let arr = []
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    // console.log(document.cookie)
    if ((arr = document.cookie.match(reg))) return unescape(arr[2])
    else return null
  }
  // 设置 cookie
  _setCookie(name, value, day = 30) {
    var date = new Date()
    date.setDate(date.getDate() + day)
    // domain=xxx.xxx.xxx;写入cookie到主域 子域名都可用    path=/表示本站全部路径都可使用
    document.cookie = `${name}=${value};expires=${date.toUTCString()};domain=${
      location.host.replace(/\./, '-').split('-')[1]
    };path=/`
  }
  // 删除cookie
  _delCookie(name) {
    this._setCookie(name, '')
  }
  // 李静减脂营 后端地址获取
  formatLjUrl(url) {
    return getEnvUrl('ljApi', url)
  }
  // 健萌2.0
  // 用户信息接口合约课接口是2.0 带isPreTest1101参数测试请求正式看数据样式
  formatTwoUrl(url) {
    // let path = 'http://app.gym2.com/' + url
    let path = 'https://t.gymcity.com.cn/' + url
    // let path = 'https://api.gymcity.com.cn/' + url
    if (
      location.href.indexOf('btvue.gymcity.com.cn') !== -1 &&
      location.href.indexOf('tbtvue.gymcity.com.cn') === -1
    ) {
      // 正式库
      path = 'https://api.gymcity.com.cn/' + url
    }
    if (location.href.indexOf('tbtvue.gymcity.com.cn') !== -1) {
      // 测试库
      if (
        location.href.indexOf('isPreTest1101') !== -1 ||
        sessionStorage.getItem('isPreTest1101')
      ) {
        // 模拟 预发环境 请求bi库 链接中携带isPreTest1101参数（配置资源位进） 或者 本地存储isPreTest1101为true
        sessionStorage.setItem('isPreTest1101', true)
        path = 'https://t_bi.gymcity.com.cn/' + url
        // path = 'https://api.gymcity.com.cn/' + url
      } else {
        path = 'https://t.gymcity.com.cn/' + url
      }
    }
    return path
  }
  // 获取token的方法
  async getJmToken() {
    // 如果已经有请求在进行中，直接返回该promise
    if (HTTP.tokenPromise) {
      return HTTP.tokenPromise
    }
    console.log('从app获取token中')
    // 创建新的promise并保存
    HTTP.tokenPromise = betterwe.addJMToken()
    return HTTP.tokenPromise
  }
  async formatParams(params) {
    // 先从cookie获取健萌tokne 公众号项目会同步在cookie健萌token
    // 鸿蒙无api获取健萌token
    let token = this._getCookie('jmToken')
    if (this._isApp() && !betterwe.isHarmony()) {
      try {
        // 等待从app api获取token
        const tokenTemp = await this.getJmToken()
        token = tokenTemp || token
      } catch (error) {
        console.log('api获取token出错用_getCookie(jmToken)', error)
      }
    }
    return {
      token: token,
      isApp: +this._isApp(),
      ...params
    }
  }
  // 李静减脂营接口
  async getLj(url, params = {}) {
    url = this.formatLjUrl(url)
    return request(url, params, 'get')
  }
  async postLj(url, params = {}) {
    url = this.formatLjUrl(url)
    // 设置 Content-Type 为 JSON，避免被拦截器序列化为 URL encoded
    const dataWithHeaders = {
      ...params,
      headerObj: { 'Content-Type': 'application/json' }
    }
    return request(url, dataWithHeaders, 'post')
  }
  async deleteLj(url, params = {}) {
    url = this.formatLjUrl(url)
    return request(url, params, 'delete')
  }
  // 健萌2.0
  async get2(url, params = {}) {
    url = this.formatTwoUrl(url)
    params = await this.formatParams(params)
    return request(url, params, 'get')
  }
  async post2(url, params = {}) {
    url = this.formatTwoUrl(url)
    params = await this.formatParams(params)
    return request(url, params, 'post')
  }
  async put2(url, params = {}) {
    url = this.formatTwoUrl(url)
    params = await this.formatParams(params)
    console.log('put2', params)
    return request(url, params, 'put')
  }
  async delete2(url, params = {}) {
    url = this.formatTwoUrl(url)
    params = await this.formatParams(params)
    return request(url, params, 'delete')
  }
  // 健萌3.0
  async get(url, params = {}) {
    params = await this.formatParams(params)
    return request(url, params, 'get')
  }
  async post(url, params = {}) {
    params = await this.formatParams(params)
    return request(url, params, 'post')
  }
  // 综训馆转介活动服务（arena，/api/referral/* 免会话直连）
  async getArena(url, params = {}) {
    return request(arenaBaseURL + url, params, 'get')
  }
  async postArena(url, params = {}) {
    return request(arenaBaseURL + url, params, 'post')
  }
  async put(url, params = {}) {
    params = await this.formatParams(params)
    return request(url, params, 'put')
  }
  all(args) {
    return axios.all(args)
  }
  /* 通用请求 */
  commonGet(url, params = {}) {
    return request(url, params, 'get')
  }
  commonPost(url, params = {}) {
    return request(url, params, 'post')
  }
  getBaseUrl() {
    let urlData = BaseData.baseUrl
    return urlData[this.curEv()]
  }
  //判断当前环境
  curEv() {
    return getCurrentEnv()
  }
  // 小程序 请求
  formatAppUrl(url) {
    return getEnvUrl('appApi', url)
  }
  getApp(url, params = {}) {
    params.headerObj = Object.assign(params.headerObj || {})
    return request(this.formatAppUrl(url), params, 'get')
  }
  postApp(url, params = {}) {
    params.headerObj = Object.assign(params.headerObj || {})
    return request(this.formatAppUrl(url), params, 'post')
  }
  /* 携带app信息 */
  getAppWithAppInfo(url, params = {}) {
    params.headerObj = Object.assign(params.headerObj || {}, headerParams)
    return request(this.formatAppUrl(url), params, 'get')
  }
  /* 携带app信息 */
  postAppWithAppInfo(url, params = {}) {
    params.headerObj = Object.assign(params.headerObj || {}, headerParams)
    return request(this.formatAppUrl(url), params, 'post')
  }
  //app端接口....
  formatApp(url) {
    return getEnvUrl('baseApp', url)
  }
  getBaseApp(url, params = {}) {
    params.headerObj = Object.assign({}, headerParams, params.headerObj || {})
    return request(this.formatApp(url), params, 'get')
  }
  postBaseApp(url, params = {}) {
    params.headerObj = Object.assign({}, headerParams, params.headerObj || {})
    return request(this.formatApp(url), params, 'post')
  }
  getBaseAppWithHeader(url, params = {}) {
    params.headerObj = Object.assign({}, headerParams, params.headerObj || {})
    return request(this.formatApp(url), params, 'get')
  }
  postBaseAppWithHeader(url, params = {}) {
    params.headerObj = Object.assign({}, headerParams, params.headerObj || {})
    return request(this.formatApp(url), params, 'post')
  }
  getBaseAppNeedLogin(url, params = {}) {
    let userInfo = store.state.userInfo
    if (!userInfo.user || !userInfo.user.unify_id) {
      //用户未登录
      betterwe.isLogin()
      return
    }
    params.headerObj = Object.assign(params.headerObj || {}, headerParams)
    return request(this.formatApp(url), params, 'get')
  }
  postBaseAppNeedLogin(url, params = {}) {
    let userInfo = store.state.userInfo
    if (!userInfo.user || !userInfo.user.unify_id) {
      //用户未登录
      //未登录
      betterwe.isLogin()
      return
    }
    params.headerObj = Object.assign(params.headerObj || {}, headerParams)
    return request(this.formatApp(url), params, 'post')
  }
  formatWeApi(url) {
    return getEnvUrl('weApi', url)
  }
  getWeApi(url, params) {
    return request(this.formatWeApi(url), params, 'get')
  }
  postWeApi(url, params) {
    return request(this.formatWeApi(url), params, 'post')
  }
  /* 获取用户信息 */
  getUserInfo() {
    return new Promise(async (resolve, reject) => {
      if (!betterwe.isApp()) {
        reject()
        return
      }
      /* 本地存在则取本地的 */
      if (_UserInfo) {
        resolve(_UserInfo)
        return
      }
      let res = await this.postBaseApp('member/AppCamp/userCenter', {
        from: 'addDataLog'
      }).catch((err) => {
        /* 如果用户信息正在获取则将当前的promise放到一个数组内 */
        if (axios.isCancel(err)) {
          userInfoApiList.push((info) => {
            resolve(info)
          })
        } else {
          reject()
        }
      })
      if (res && res.data && res.data.code == 200 && res.data.data.user) {
        _UserInfo = res.data.data.user
        resolve(res.data.data.user)
        /* 将收集到的promise全部执行 */
        userInfoApiList.map((item) => {
          item(res.data.data.user)
        })
        userInfoApiList = []
      } else {
        reject()
      }
    })
  }
  // 记录app elk日志
  async addAppElkLog(content) {
    if (betterwe.isApp()) {
      const token = await betterwe.getAppToken()
      if (!token) {
        return
      }
      if (!appDeviceInfo) {
        appDeviceInfo = await betterwe.getAppDevicesInfo().catch(() => {})
      }
      const params = {
        token,
        name: '0300024',
        deviceId: appDeviceInfo.deviceid,
        content
      }
      this.getBaseApp('tool/AppLog/setLogV2', params)
    } else {
      console.log('健萌token错误埋点：不在app内')
    }
  }
  //数据统计接口 {eventk,eventv}
  async addDataLog(params = {}) {
    let userinfo = await this.getUserInfo().catch(() => {})
    let uid = userinfo?.id || 0
    if (!appDeviceInfo) {
      appDeviceInfo = await betterwe.getAppDevicesInfo().catch(() => {})
    }
    let url = getEnvUrl('dataLog')
    let data = {
      eventv: '',
      eventk: '',
      time: dataObj.getShortFullTimeStr(new Date().getTime()),
      uid, //用户id
      net: appDeviceInfo?.networktype || 6, //网络环境
      os: getClientplatform(appDeviceInfo?.clientplatform), //系统类型 android ios windows
      sysver: appDeviceInfo?.deviceversion, //操作系统版本号
      appver: appDeviceInfo?.clientversion, //app版本数
      appname: appDeviceInfo?.clientname, //应用版本号
      did: appDeviceInfo?.deviceid, //设备id
      oaid: '',
      mod: appDeviceInfo?.devicemodel, //手机型号
      isreview: appDeviceInfo?.isexamined, //是否审核模式
      channel: appDeviceInfo?.appchannel, //来源渠道区分
      source: 3, //访问来源区分 1:APP 2:小程序 3:H5/WEB
      brand: appDeviceInfo?.brand,
      manufacturer: appDeviceInfo?.manufacturer
    }
    Object.assign(data, params)
    let param = Object.assign({}, data)
    param.headerObj = data
    return request(url, param, 'post')
  }
  //获取用户数据
  async getUserData() {
    let res = await this.postBaseApp('member/AppCamp/userCenter', {
      from: 'common'
    })
    if (res.data && res.data.code == 200 && res.data.data) {
      store.commit('setUserInfo', res.data.data)
    }
  }
  //获取资源位需要携带app信息到header
  getAdvData(url, params) {
    if (this._isApp()) {
      return new Promise((resolve, reject) => {
        betterwe
          .getAppDevicesInfo()
          .then((res) => {
            let headerObj = {
              env: '',
              deviceversion: '',
              clientplatform: '',
              clientversion: '',
              clientname: '',
              deviceid: '',
              manufacturer: '',
              brand: '',
              lat: '',
              lon: '',
              appchannel: '',
              useragent: '',
              idfa: '',
              isexamined: ''
            }
            for (let key in headerObj) {
              if (res[key]) {
                headerObj[key] = res[key]
              }
            }
            params.headerObj = headerObj
            request(this.formatApp(url), params, 'get')
              .then((res) => {
                resolve(res)
              })
              .catch((err) => {
                reject(err)
              })
          })
          .catch((res) => {
            //Toast(JSON.stringify(res));
            reject()
          })
      })
    } else {
      return request(this.formatApp(url), params, 'get')
    }
  }
  init() {
    if (!store.state.location) {
      if (this._getQuery('lat')) {
        // 坐标转换
        const { lat, lng } = this.gcj_decrypt(
          this._getQuery('lat'),
          this._getQuery('lng')
        )
        store.commit('saveLocation', {
          lat,
          lng
        })
        // 请求全局接口info/home
        this.loadGoalData()
      } else {
        // this.homeinfo()
        // this.userinfo()
        //新版不传入地理位置需要h5获取
        betterwe
          .requestLocation()
          .then((res) => {
            if (res.errorCode == 0) {
              console.log('获取到经纬度', res)
              // 坐标转换
              const { lat, lng } = this.gcj_decrypt(res.latitude, res.longitude)
              store.commit('saveLocation', {
                lat,
                lng
              })
              // 从app获取到经纬度后再次请求
            } else {
              // Toast('获取位置失败，请检查APP定位设置')
            }
          })
          .catch((e) => {
            // Toast('获取位置失败，请检查APP定位设置')
            console.log(e)
          })
          .finally(() => {
            // 请求全局接口info/home
            this.loadGoalData()
          })
      }
    } else {
      // 已经获取到位置信息则直接请求全局接口info/home
      this.homeinfo()
      this.userinfo()
    }
    // this._getLocation()
  }

  // 请求全局接口info/home
  loadGoalData() {
    // 判断当前页面是否为 subscribe 页面
    const isSubscribePage = this._isSubscribePage()
    if (isSubscribePage) {
      // 初始化时是约课列表页则请求双home接口
      this._initSubscribePage()
    } else {
      this.homeinfo()
      this.userinfo()
    }
  }
  // 判断当前页面是否为 subscribe 页面
  _isSubscribePage() {
    // 通过路由路径判断
    const currentPath = window.location.hash || window.location.pathname
    return (
      currentPath.includes('subscribe') || currentPath.includes('appointment')
    )
  }

  // subscribe 页面的双接口初始化策略
  _initSubscribePage(lat = '', lng = '') {
    // 1. 先请求第一门店数据，快速显示
    this.homeinfo('', '', '', true).then((res) => {
      // 2. 等第一个请求完成后再请求完整数据
      this.homeinfo('', '', '', false)
    })

    // 同时请求用户信息
    this.userinfo('', '', '')
  }
  // getAppLocation() {
  //   return new Promise(async (resolve, reject) => {
  //     if (
  //       this._isApp() &&
  //       betterwe.isPermissionDialogHappened('requestLocation')
  //     ) {
  //       let res = await betterwe.commonMethod('requestLocation').catch(() => {})
  //       if (res !== undefined) {
  //         resolve(typeof res === 'string' ? JSON.parse(res) : res)
  //       }
  //     } else {
  //       reject('获取位置失败')
  //     }
  //   })
  // }
  //  未知原因默认配置的请求无法正常获得index/getip的返回数据 应该是配置问题
  // （已找到问题， 限制返回类型是JSON时 此接口接收不到数据）
  // 重写获取ip
  getIp() {
    const axiosInstance = axios.create({ withCredentials: true }) // withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
    return axiosInstance({
      method: 'GET',
      data: {},
      url: this.formatTwoUrl('index/getip'), // 上传地址
      timeout: 30000 // 超时时间，
    })
  }

  // 约课列表
  homeinfo(lat = '', lng = '', regionCode = '', onlyFirstShop = false) {
    lat = lat || (store.state.location && store.state.location.lat)
    lng = lng || (store.state.location && store.state.location.lng)

    let change = (res, onlyFirstShop = false) => {
      // 优化1: 使用 Object.entries 替代 for...in 循环，性能更好
      let day_info = []
      const data = res.data
      // 优化2: 使用 Object.keys 和 forEach，避免 for...in 的性能问题
      const keys = Object.keys(data)
      keys.forEach((key) => {
        if (data[key]['day_info']) {
          day_info.push(data[key]['day_info'])
          delete data[key]['day_info']
        }
      })
      // 优化3: 减少重复的 store.commit 调用
      const storeData = {
        dayinfo: day_info,
        course: data['last_course'],
        homedata: { ...data }
      }
      // 删除不需要的字段
      delete storeData.homedata['last_course']
      // 批量提交到 store
      store.commit('dayinfo', storeData.dayinfo)
      store.commit('course', storeData.course)
      store.commit('homedata', storeData.homedata)
      if (!onlyFirstShop) {
        // 请求完整数据 更新标志位
        store.commit('initAllShop', true)
      }
    }

    return this.get2('index/home', {
      lat,
      lng,
      regionCode,
      onlyFirstShop: onlyFirstShop ? 1 : 0
    })
      .then((res) => {
        localStorage.setItem('home', JSON.stringify(res))
        change(res, onlyFirstShop)
        regionCode && Toast.clear()
        return res
      })
      .catch((error) => {
        console.log('❌ homeinfo接口请求失败:', error)
        throw error
      })
    // Toast.clear()
  }

  // 会员信息
  userinfo(lat = '', lng = '', regionCode = '') {
    lat = lat || (store.state.location && store.state.location.lat)
    lng = lng || (store.state.location && store.state.location.lng)
    let change = (user) => {
      // 存储门店列表
      store.commit('pushshopList', user.data.data.shop)
      // 用户信息汇总
      store.commit('user', user.data.data)
      // 同步当前城市
      store.commit('setCurCity', user.data.data.current_city)
    }
    this.get2('user/info', { lat, lng, regionCode }).then((user) => {
      localStorage.setItem('user', JSON.stringify(user))
      if (user.data.data.integral) change(user)
      regionCode && Toast.clear()
      // console.log('User/info:', user)
    })
    // Toast.clear()
  }

  PI = 3.14159265358979324
  x_pi = (3.14159265358979324 * 3000.0) / 180.0
  delta(lat, lon) {
    // Krasovsky 1940
    //
    // a = 6378245.0, 1/f = 298.3
    // b = a * (1 - f)
    // ee = (a^2 - b^2) / a^2;
    var a = 6378245.0 //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
    var ee = 0.00669342162296594323 //  ee: 椭球的偏心率。
    var dLat = this.transformLat(lon - 105.0, lat - 35.0)
    var dLon = this.transformLon(lon - 105.0, lat - 35.0)
    var radLat = (lat / 180.0) * this.PI
    var magic = Math.sin(radLat)
    magic = 1 - ee * magic * magic
    var sqrtMagic = Math.sqrt(magic)
    dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * this.PI)
    dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * this.PI)
    return { lat: dLat, lon: dLon }
  }
  //GCJ-02 to WGS-84
  gcj_decrypt(gcjLat, gcjLon) {
    // var d = this.delta(gcjLat, gcjLon)
    // return { lat: gcjLat - d.lat, lng: gcjLon - d.lon }
    // 2023-08-10 17:18:06 目前app定位插件在各手机偏差一致，做手动修正
    return { lat: gcjLat, lng: gcjLon } // 2022年09月05日 app直接传的WGS-84
  }
  transformLat(x, y) {
    var ret =
      -100.0 +
      2.0 * x +
      3.0 * y +
      0.2 * y * y +
      0.1 * x * y +
      0.2 * Math.sqrt(Math.abs(x))
    ret +=
      ((20.0 * Math.sin(6.0 * x * this.PI) +
        20.0 * Math.sin(2.0 * x * this.PI)) *
        2.0) /
      3.0
    ret +=
      ((20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin((y / 3.0) * this.PI)) *
        2.0) /
      3.0
    ret +=
      ((160.0 * Math.sin((y / 12.0) * this.PI) +
        320 * Math.sin((y * this.PI) / 30.0)) *
        2.0) /
      3.0
    return ret
  }
  transformLon(x, y) {
    var ret =
      300.0 +
      x +
      2.0 * y +
      0.1 * x * x +
      0.1 * x * y +
      0.1 * Math.sqrt(Math.abs(x))
    ret +=
      ((20.0 * Math.sin(6.0 * x * this.PI) +
        20.0 * Math.sin(2.0 * x * this.PI)) *
        2.0) /
      3.0
    ret +=
      ((20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin((x / 3.0) * this.PI)) *
        2.0) /
      3.0
    ret +=
      ((150.0 * Math.sin((x / 12.0) * this.PI) +
        300.0 * Math.sin((x / 30.0) * this.PI)) *
        2.0) /
      3.0
    return ret
  }
  // 获取定位经纬度 re为1时 实时返回经纬度并不请求home info 接口
  _getLocation(re = 0) {
    if (qq && new qq.maps.Geolocation()) {
      const geolocation = new qq.maps.Geolocation()
      geolocation.getLocation(
        (position) => {
          //定位数据获取成功响应
          console.log('====================================')
          console.log('定位', position)
          console.log('====================================')
          // Dialog.alert({
          //   message:
          //     "纬度: " +
          //     position.lat +
          //     "\n" +
          //     "经度: " +
          //     position.lng +
          //     "\n" +
          //     "地址: " +
          //     position.addr
          // })
          // 转化坐标系
          const { lat, lng } = this.gcj_decrypt(position.lat, position.lng)
          console.log('====================================')
          console.log('定位纠正', lat, lng)
          console.log('====================================')
          store.commit('saveLocation', {
            lat,
            lng
          })
          if (re) {
            return {
              lat,
              lng
            }
          } else {
            this.homeinfo(lat, lng)
            this.userinfo(lat, lng)
          }
        },
        (error) => {
          //定位数据获取失败响应
          console.log('====================================')
          console.log('定位error', error)
          console.log('====================================')
          Toast('获取定位信息失败' + JSON.stringify(error))
          store.commit('saveLocation', {
            lat: '',
            lng: ''
          })
          if (re) {
            return {
              lat: '',
              lng: ''
            }
          } else {
            this.homeinfo()
            this.userinfo()
          }
          // switch (error.code) {
          //   case error.PERMISSION_DENIED:
          //     Toast("您拒绝对获取地理位置的请求")
          //     break
          //   case error.POSITION_UNAVAILABLE:
          //     Toast("位置信息是不可用的")
          //     break
          //   case error.TIMEOUT:
          //     Toast("请求您的地理位置超时")
          //     break
          //   case error.UNKNOWN_ERROR:
          //     Toast("未知错误")
          //     break
          // }
        }
      )
    } else {
      Toast('您的浏览器不支持使用HTML 5来获取地理位置服务')
      this.homeinfo()
      this.userinfo()
    }
  }

  getLogId(id) {
    return (
      Number(id).toString(35) +
      'z' +
      Number((new Date().getTime() / 1000).toFixed(0)).toString(36)
    )
  }
  // dataURLtoFile(dataurl, filename) {
  //   // 将base64转换为文件
  //   let arr = dataurl.split(',')
  //   let mime = arr[0].match(/:(.*?);/)[1]
  //   let bstr = atob(arr[1])
  //   let n = bstr.length
  //   let u8arr = new Uint8Array(n)
  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n)
  //   }
  //   return new File([u8arr], filename, { type: mime })
  // }
  // base64转file
  base64ToFile(base64Data, filename) {
    var byteString
    if (base64Data.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(base64Data.split(',')[1])
    else byteString = unescape(base64Data.split(',')[1])
    var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
    var ia = new Uint8Array(byteString.length)
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    const blob = new Blob([ia], { type: mimeString })
    filename = filename || new Date().getTime() + '.png'
    // 使用Uint8Array创建Blob对象，然后使用Blob对象创建File对象
    return new File([blob], filename, { type: mimeString })
  }
  base64ToPngFile(base64Data, fileName = '图片.png') {
    // 移除Base64前缀（如"data:image/png;base64,"）
    const base64WithoutPrefix = base64Data.replace(
      /^data:image\/\w+;base64,/,
      ''
    )

    // 转换为二进制数据
    const binaryString = atob(base64WithoutPrefix)
    const bytes = new Uint8Array(binaryString.length)

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }

    // 创建Blob对象（指定为PNG类型）
    const blob = new Blob([bytes], { type: 'image/png' })

    // 转换为File对象
    return new File([blob], fileName, {
      type: 'image/png',
      lastModified: Date.now()
    })
  }
  // 统一上传图片
  uploadImg(file, oss_file, id) {
    if (typeof file === 'string' && file.includes('base64')) {
      file = this.base64ToFile(file)
    }
    console.log('uploadImg', file, file.name)
    let url = getEnvUrl('imageUpload')
    const axiosInstance = axios.create({ withCredentials: false }) // withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
    let formData = new FormData()
    formData.append('token', this._getCookie('jmToken')) // 七牛需要的token，叫后台给，是七牛账号密码等组成的hash
    formData.append('image', file) // 文件
    formData.append('oss_file', oss_file) // 存放的文件夹 传当前活动简称字符串
    formData.append('photo_img', 'image') // 放文件的键名
    formData.append('a', 'photoUpload')
    formData.append('id', id) //  接口会原封返回 循环或多张图片上传时用于定位图片
    return axiosInstance({
      method: 'POST',
      url: url, // 上传地址
      data: formData,
      timeout: 30000, // 超时时间，因为图片上传有可能需要很久
      onUploadProgress: (progressEvent) => {
        // imgLoadPercent 是上传进度，可以用来添加进度条
        let imgLoadPercent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log('imgLoadPercent', imgLoadPercent)
      }
    })
  }
  uploadAppImage(file, type = 1) {
    const axiosInstance = axios.create({ withCredentials: false }) // withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
    let formData = new FormData()
    formData.append('img_data', file) // 文件
    formData.append('upload_type', type)
    console.log('表单数据是：', file)
    return axiosInstance({
      method: 'POST',
      url: this.formatApp('member/OssAuth/uploadImg'), // 上传地址
      data: formData,
      headers: {
        token: _getCookie('token')
      },
      timeout: 30000, // 超时时间，因为图片上传有可能需要很久
      onUploadProgress: (progressEvent) => {
        // imgLoadPercent 是上传进度，可以用来添加进度条
        let imgLoadPercent = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        console.log('imgLoadPercent', imgLoadPercent)
      }
    })
  }
  // 获取oss凭证 健萌
  // getOssObj() {
  //   return new Promise((resolve, reject) => {
  //     this.get('member/index?a=ossAuth', {}, true)
  //       .then((res) => {
  //         if (res.data.code === 200) {
  //           const ossObj = {
  //             region: 'oss-cn-beijing',
  //             secure: true, // https
  //             bucket: 'wegymer-vue', // 新版用 wegym-vue
  //             accessKeyId: res.data.data.AccessKeyId,
  //             accessKeySecret: res.data.data.AccessKeySecret,
  //             stsToken: res.data.data.SecurityToken
  //           }
  //           // @ts-ignore
  //           resolve(new OSS(ossObj))
  //         } else {
  //           // Toast("阿里云token获取失败");
  //           reject()
  //         }
  //       })
  //       .catch((err) => {
  //         // Toast("阿里云token获取失败");
  //         reject()
  //       })
  //   })
  // }
  //获取凭证 减脂营
  getOSSAuth(file) {
    return new Promise((resolve, reject) => {
      this.getApp('member/OssAuth/getAuth', {})
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.uploadOssImage(res.data, file)
              .then((res) => {
                resolve(res)
              })
              .catch((err) => {
                reject(err)
              })
          } else {
            Toast(res.msg)
          }
        })
        .catch(() => {
          reject(err)
        })
    })
  }
  //oss上传接口
  uploadOss(file) {
    return new Promise((resolve, reject) => {
      this.getOSSAuth(file)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  //上传图片至oss
  uploadOssImage(data, file) {
    let dir = data.dir + 'betterwe_h5/' + new Date().getTime()
    let fullPath = data.cdn_url + '/' + dir
    const axiosInstance = axios.create({ withCredentials: false }) // withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
    let formData = new FormData()
    formData.append('key', dir)
    formData.append('accessid', data.accessid)
    formData.append('expire', data.expire)
    formData.append('policy', data.policy)
    formData.append('Signature', data.signature)
    formData.append('OSSAccessKeyId', data.accessid)
    formData.append('success_action_status', 200)
    formData.append('file', file)
    return new Promise((resolve, reject) => {
      axiosInstance({
        method: 'POST',
        url: data.host, // 上传地址
        data: formData,
        timeout: 30000 // 超时时间，因为图片上传有可能需要很久
      })
        .then((res) => {
          res.fullPath = fullPath
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  //h5数据统计
  addLog(from) {
    let params = {
      from,
      type: 4,
      key: 'kDTSxgHiV6XFwFGJ'
    }
    return this.postApp('tool/ShareLog/spotLog', params)
  }
  //替换url中的指定name的值
  eplaceQueryString(url, name, value) {
    const re = new RegExp(name + '=[^&]*', 'gi')
    return url.replace(re, name + '=' + value)
  }
  //app内webview返回按钮
  appBack() {
    if (this._isApp()) {
      betterwe.onWebViewBack()
    } else {
      router.go(-1)
    }
  }
  /* 页面曝光埋点 */
  bindPageUMA() {
    const { aplus_queue } = window
    aplus_queue.push({
      action: 'aplus.sendPV',
      arguments: [{ is_auto: false }] // 此处上报的数据暂时在后台没有展示
    })
  }
  /* 
    @param 事件id
    @param 参数
  */
  bindH5UMA(eventCode, eventParams = '') {
    console.log('事件code:' + eventCode)
    //暂时在友盟埋点的同时调用betterwe项目后台统计
    this.addDataLog({ eventk: eventCode, eventv: eventParams })
    window['aplus_queue'] &&
      window['aplus_queue'].push({
        action: 'aplus.record',
        arguments: [eventCode, 'CLK', eventParams]
      })
  }
  bindH5UMAList(arr) {
    if (Array.isArray(arr)) {
      arr.map((item) => {
        if (item.eventk) {
          this.bindH5UMA(item.eventk, item.eventv)
        }
      })
    }
  }
  //调用app的友盟埋点
  bindUMA(eventId, params = {}) {
    if (this._isApp()) {
      let paramsObj = []
      for (let key in params) {
        if (params[key] !== undefined) {
          paramsObj.push({
            key: key,
            value: JSON.stringify(params[key])
          })
        }
      }
      let obj = {
        eventId: eventId,
        params: paramsObj
      }
      //临时添加 调用友盟app埋点时调用betterwe数据统计
      this.addDataLog({ eventk: eventId, eventv: JSON.stringify(params) })
      betterwe.sendUMEvent(obj)
    }
  }
  //app端发送用户行为
  sendUserAct(type, key = 'user_incoming_line') {
    let params = {
      headerObj: {
        useragent: navigator.userAgent
      },
      act_key: key,
      act_value: type
    }
    this.postBaseApp('member/ads.userAct/record', params).then((res) => {})
  }
  getWxConfig() {
    let params = {
      url: encodeURIComponent(location.href.split('#')[0])
    }
    return this.postBaseApp('que/QueBase/getJsApiInfo', params)
  }
  //预请求文件 判断文件是否存在
  headFile(url) {
    const axiosInstance = axios.create({
      withCredentials: false,
      timeout: 10000,
      responseType: 'json',
      changeOrigin: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    })
    // 返回响应拦截器
    axiosInstance.interceptors.response.use(
      async (res) => {
        return res
      },
      (error) => {
        console.log('文件不存在', error)
        if (typeof error.response === 'undefined') {
          /* http status  === 0时 部分低版本手机浏览器阻止head请求直接返回status = 0导致请求失败 */
          return Promise.resolve({ status: 200, msg: '' })
        }
        //404等问题可以在这里处理
        return Promise.reject(error)
      }
    )
    return axiosInstance({
      method: 'head',
      url,
      data: {}
    })
  }
}
const https = new HTTP()
Vue.prototype.$http = https
export default https
// export default http;
